// Utilidades compartidas para los adjuntos del ticket (chat y panel lateral)

export const esImagen = (url) => /\.(jpg|jpeg|png|gif|webp|avif)$/i.test(url || '');

export const esPdf = (url) => /\.pdf$/i.test(url || '');

export const sePuedePrevisualizar = (url) => esImagen(url) || esPdf(url);

export const getFileName = (url, length = 10) => {
    const fileName = String(url || '').substring(String(url || '').lastIndexOf('/') + 1);
    const extensionIndex = fileName.lastIndexOf('.');
    if (extensionIndex === -1) return fileName;

    const name = fileName.substring(0, extensionIndex);
    const extension = fileName.substring(extensionIndex);
    const shortenedName = name.length > length ? `${name.substring(0, length)}...` : name;
    return shortenedName + extension;
};

export const getIconUrl = (file) => {
    const extension = String(file || '').split('.').pop().toLowerCase();
    switch (extension) {
        case 'png':
        case 'jpg':
        case 'jpeg':
            return '/images/imagen-icono.svg';
        case 'xlsx':
            return '/images/excel.svg';
        case 'psd':
        case 'gif':
        case 'zip':
        case 'docx':
        case 'doc':
        case 'svg':
        case 'pdf':
        case 'csv':
            return `/images/${extension}.svg`;
        default:
            return '/images/almacenamiento-de-archivos.svg';
    }
};
